/* =================
 * STICKY radio
 * über complex sticky radio
 * crazy stuff courtesy of design
 * =================
 */

import { debounce } from "underscore";


export class RadioSticky {
    // staff
    doc = $(document);
    win = $(window);
    header = $('header');
    footer = $('footer');
    radio;

    // request animation frame thread id
    rafId;

    // initials
    lastPosition = 0;
    radioOffsetY = 0;
    radioHeight = 0;
    offsetUpY = 0;
    offsetDownY = 0;

    // flags: stoped (lock and unlock)
    // sticked! state
    stoped = false;
    pinned = false;

    // options: offset delta margin
    offset = 25;

    listening = false;

    constructor(el) {
        this.radio = el;
        if (!this.radio.length) {
            return;
        }

        this.init();
    }

    init() {
        // do first data update
        this.updateData(true);

        this.scroll();
        this.removeSticky();

        this.win.resize(debounce(() => {
            this.update();
        }, 120));

        // bind on resize size changes (RWD)
        this.win.resize(debounce(() => {
            this.lock();

            if (this.pinned) {
                this.radio.removeClass('radio-fixed');
                this.radioHeight = this.getRadioHeight();
                this.radio.addClass('radio-fixed');
                this.applyRoom();
            } else {
                this.updateData();
            }

            this.unlock();
        }, 200));
    }

    removeSticky() {
        $('.radio__close-button').on('click', (e) => {
            e.preventDefault();
            this.radio.removeClass('radio-fixed');
        });
    }

    // do scroll loop
    scroll() {
        // Avoid not needed calculations
        if (this.stoped || this.lastPosition === window.pageYOffset) {
            this.rafId = window.requestAnimationFrame(() => this.scroll());
            return false;
        } else {
            this.lastPosition = window.pageYOffset | 0;
        }

        if (this.lastPosition >= this.offsetUpY && !this.pinned) {
            // avoid exceeding doc bounds (bouncing issue)
            if ((this.lastPosition + this.radioHeight + this.win.height()) < this.doc.height()) {
                this.radio.addClass('radio-fixed');
                this.applyRoom();
                this.pinned = true;
            }
        } else if (this.lastPosition <= this.offsetDownY && this.pinned) {
            this.radio.removeClass('radio-fixed');
            this.footer.css('paddingBottom', '');
            this.pinned = false;
        }

        // request
        this.rafId = window.requestAnimationFrame(() => this.scroll());
    };

    lock() {
        return this.stoped = true;
    }

    unlock() {
        return this.stoped = false;
    }

    update() {
        // first try (force unpin)
        this.updateData();
        // last trial (raf and css animations coordination)
        (this.update = () => {
            // back to previous state (if were pinned)
            if (!this.pinned) {
                this.updateData();
                return;
            }
            window.setTimeout(this.update, 100);
        })();
    }

    //
    // internal functions
    //

    // updateData: pre calculate data to get better perfs
    updateData(forceRecalc) {
        this.lastPosition = forceRecalc ? -1 | 0 : this.lastPosition; // Force a recalculation if set
        this.radioOffsetY = this.radio.offset().top | 0;
        this.radioHeight = this.getRadioHeight();
        this.offsetUpY = (this.radioOffsetY + this.offset + this.radioHeight - this.header.height()) | 0;
        this.offsetDownY = (this.radioOffsetY + this.radioHeight - this.header.height()) | 0;
    }

    // apply top room compensatory space
    applyRoom() {
        const currPad = Math.round(parseFloat(this.footer.css('paddingBottom')));
        if (this.radioHeight !== currPad) {
            this.footer.css('paddingBottom', this.radioHeight);
        }
    }

    //
    // helpers
    //

    getRadioHeight() {
        return Math.round(parseFloat(this.radio.not('.radio-fixed').outerHeight())) || this.radioHeight;
    }
}
